import React from 'react';
import styled from 'styled-components';
import {SVG, Circle, Silhouette} from './ui';

export interface SVGAuthorsProps {
    id: string;
    overlap?: number;
    images: (string | undefined)[];
    className?: string;
}

export const UnstyledSVGAuthors = ({overlap = 1 / 3, images, ...props}: SVGAuthorsProps) => {
    const normalizedOverlap = Math.min(Math.max(overlap, 0.0), 1.0);
    const hasOverlap = normalizedOverlap !== 0.0 && images.length > 1;
    const overlapCenter = hasOverlap ? (normalizedOverlap - 0.5) * 48 : -24;
    const overlapWidth = (1.0 - normalizedOverlap) * 48;
    const totalWidth = 48 + (images.length - 1) * overlapWidth;

    return (
        <SVG viewBox={`0 0 ${totalWidth} 48`} {...props}>
            <defs>
                <mask id={`circle-${props.id}`}>
                    <circle cx="24" cy="24" r="24" fill="white" />
                </mask>

                {hasOverlap && (
                    <mask id={`overlap-${props.id}`}>
                        <circle cx="24" cy="24" r="24" fill="white" />
                        <circle cx={overlapCenter} cy="24" r="26" fill="black" />
                    </mask>
                )}
            </defs>

            {images.map((href, index) => {
                const groupProps =
                    index === 0
                        ? {
                              mask: `url(#circle-${props.id}`
                          }
                        : {
                              mask: `url(#${hasOverlap ? `overlap-${props.id}` : `circle-${props.id}`})`,
                              transform: `translate(${overlapWidth * index}, 0)`
                          };

                const image = href ? (
                    <image href={href} width="48" height="48" />
                ) : (
                    <g mask={`url(#circle-${props.id}`}>
                        <Circle cx="24" cy="24" r="24" />
                        <Silhouette
                            d="M34.698 18.507c0 5.862-4.805 10.507-10.698 10.507-5.893 0-10.698-4.72-10.698-10.507S18.107 8 24 8c5.893 0 10.698 4.645 10.698 10.507zM44 51.318c0 6.243-40 6.243-40 0 0-9.287 8.914-18.652 20-18.652s20 9.365 20 18.652z"
                            mask={`url(#$mask-{props.id})`}
                        />
                    </g>
                );

                return (
                    <g key={index} {...groupProps}>
                        {image}
                    </g>
                );
            })}
        </SVG>
    );
};

export const SVGAuthors = styled(UnstyledSVGAuthors)<SVGAuthorsProps>``;
